import DespachosReporte from "./DespachosReporte";
import { useStoreDespachos } from "./useStoreDespachos";
import demo from "../../icons/pregunta.png"
import Mensaje from "sweetalert";
import TablaAgrupada from "../../ComponentesGlobales/TablaAgrupada";
import {
    descargarPDFProducto,
    generarPDFsMultiples,
    normalizarProducto,
    descargarPDFMultiplesUnificado,
    mostrarPDFProductoEnVentana,
    mostrarPDFMultiplesEnVentana,
    procesarPDF
} from '../../utils/pdfGenerator';
import { OpcionesEtiqueta } from '../../utils/OpcionesEtiqueta';
import moment from "moment";

const DespachoTab3 = () => {

    const ListaGrillaPantalla = useStoreDespachos((s) => s.ListaGrillaPantalla);
    const Fecha = useStoreDespachos((state) => state.Fecha);


    // Función para generar PDF con QR de un solo producto
    const generarPDFProducto = async (producto, opcionesExtra = {}) => {
        try {
            const productoNormalizado = normalizarProducto(producto);
            await descargarPDFProducto(productoNormalizado, {
                titulo: 'Información del Producto - PISeun',
                mostrarFecha: true,
                ...opcionesExtra
            });

            toast.current?.show({
                severity: 'success',
                summary: 'PDF Generado',
                detail: `PDF generado para ${productoNormalizado.descripcion}`,
                life: 3000
            });
        } catch (error) {
            console.error('Error generando PDF:', error);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al generar el PDF: ' + error.message,
                life: 4000
            });
        }
    };

    // Función para generar PDFs múltiples
    const generarPDFsSeleccionados = async (productos, opcionesExtra = {}) => {
        try {
            if (!productos || productos.length === 0) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Sin selección',
                    detail: 'No hay productos seleccionados para generar PDF',
                    life: 3000
                });
                return;
            }

            // Mostrar loading
            toast.current?.show({
                severity: 'info',
                summary: 'Generando PDFs',
                detail: `Generando ${productos.length} archivo(s) PDF...`,
                life: 2000
            });

            const productosNormalizados = productos.map(p => normalizarProducto(p));
            const pdfs = await generarPDFsMultiples(productosNormalizados, {
                titulo: 'Productos - PISeun',
                mostrarFecha: true,
                ...opcionesExtra
            });

            // Descargar cada PDF
            pdfs.forEach(({ pdf, nombre }) => {
                pdf.save(nombre);
            });

            toast.current?.show({
                severity: 'success',
                summary: 'PDFs Generados',
                detail: `Se generaron ${pdfs.length} archivos PDF exitosamente`,
                life: 4000
            });

        } catch (error) {
            console.error('Error generando PDFs múltiples:', error);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al generar los PDFs: ' + error.message,
                life: 4000
            });
        }
    };

    // Función para generar PDF unificado
    const generarPDFUnificado = async (productos, opcionesExtra = {}) => {
        try {
            if (!productos || productos.length === 0) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Sin selección',
                    detail: 'No hay productos seleccionados para generar PDF',
                    life: 3000
                });
                return;
            }

            toast.current?.show({
                severity: 'info',
                summary: 'Generando PDF Unificado',
                detail: `Generando documento único con ${productos.length} producto(s)...`,
                life: 2000
            });

            const productosNormalizados = productos.map(p => normalizarProducto(p));

            await descargarPDFMultiplesUnificado(productosNormalizados, {
                titulo: 'Listado de Productos - PISeun',
                mostrarFecha: true,
                productosPorPagina: 2,
                numerarProductos: true,
                encabezado: 'Reporte generado desde Ingresos - Sistema PISeun',
                ...opcionesExtra
            });

            toast.current?.show({
                severity: 'success',
                summary: 'PDF Unificado Generado',
                detail: `Documento único con ${productos.length} producto(s) descargado exitosamente`,
                life: 4000
            });

        } catch (error) {
            console.error('Error generando PDF unificado:', error);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al generar el PDF unificado: ' + error.message,
                life: 4000
            });
        }
    };

    const handlePrint = async (nivel, { records }) => {
        try {
            // Primero preguntar si quiere ver en ventana emergente o descargar
            const vistaOpcion = await new Promise((resolve) => {
                Mensaje({
                    title: "¿Cómo deseas ver el PDF?",
                    text: `${records.length} producto(s) seleccionado(s)`,
                    icon: "info",
                    buttons: {
                        ventana: { text: "🔍 Ver en Ventana", value: "ventana", className: "btn-primary" },
                        descargar: { text: "⬇️ Descargar", value: "descargar", className: "btn-success" },
                        cancel: { text: "Cancelar", value: null, className: "btn-secondary" }
                    }
                }).then(resolve);
            });

            if (!vistaOpcion) return; // Cancelado

            let opcionesPDF;
            try {
                opcionesPDF = await OpcionesEtiqueta(records.length);
            } catch (e) {
                // cancelado o inválido → no sigo
                return;
            }

            if (records.length === 1) {
                // Un solo registro
                if (vistaOpcion === "ventana") {
                    await mostrarPDFProductoEnVentana(records[0], opcionesPDF);
                } else {
                    await generarPDFProducto(records[0], opcionesPDF);
                }
            } else {
                // Múltiples registros - mostrar opciones de formato

                if (vistaOpcion !== "ventana") {
                    const formatoOpcion = await new Promise((resolve) => {
                        Mensaje({
                            title: "¿Cómo deseas generar los documentos?",
                            text: `${records.length} productos seleccionados`,
                            icon: "info",
                            buttons: {
                                unificado: {
                                    text: "📑 PDF Unificado",
                                    value: "unificado",
                                    className: "btn-success"
                                },
                                separados: {
                                    text: "📚 PDFs Separados",
                                    value: "separados",
                                    className: "btn-info"
                                },
                                cancel: {
                                    text: "Cancelar",
                                    value: null,
                                    className: "btn-secondary"
                                }
                            }
                        }).then(resolve);
                    });

                    if (!formatoOpcion) return; // Cancelado

                    if (formatoOpcion === "unificado") {
                        if (vistaOpcion === "ventana") {

                            await mostrarPDFMultiplesEnVentana(records, opcionesPDF);
                        } else {

                            await generarPDFUnificado(records, opcionesPDF);
                        }
                    } else if (formatoOpcion === "separados") {
                        // Para PDFs separados, solo opción de descarga por ahora
                        if (vistaOpcion === "ventana") {
                            toast.current?.show({
                                severity: 'info',
                                summary: 'Información',
                                detail: 'Vista en ventana no disponible para PDFs separados. Se procederá con la descarga.',
                                life: 3000
                            });
                        }
                        await generarPDFsSeleccionados(records, opcionesPDF);
                    }
                }
                else {
                    const productosNormalizados = records.map(p => normalizarProducto(p));
                    await mostrarPDFMultiplesEnVentana(productosNormalizados, opcionesPDF);
                }
            }
        } catch (error) {
            console.error('Error en handlePrint:', error);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al procesar la solicitud: ' + error.message,
                life: 4000
            });
        }
    };

    return (
        <div className="desp-registros">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 className="ing-subtitulo">
                    {' '}
                    {`Detalles de Despachos`}
                </h3>


                <div style={{ display: 'flex', justifyContent: 'flex-start', marginRight: "20px" }}>
                    <DespachosReporte />
                </div>


            </div>

            <div className="desp-detalle">


                <TablaAgrupada
                    data={ListaGrillaPantalla}
                    groupBy={[
                        { label: "Cliente", key: (r) => r.ClienteDescripcion + ` (Nro de despacho: ${r.Despacho_Id})` },
                    ]}
                    rowId={(r) => r.Id ?? r.IdentificadorId ?? r.MercaderiaId}

                    columns={[
                        { header: "Código QR", field: "sCodbar", width: 200, align: "left" },
                        { header: "Producto", field: "sDescripcion", width: 200, align: "left" },
                        { header: "Cantidad", field: "Peso", width: 120, align: "center" },
                        { header: "Unidad", field: "UnidadDescripcion", width: 120, align: "center" },
                        { header: "Lote", field: "sLote", width: 120, align: "center" },
                        { header: "QR Salida", field: "Original", width: 120, align: "center" },
                    ]}
                    onDelete={(nivel, { records, node }) => {
                        const nombre = node?.data?.label;
                        const titulo = `Eliminar ${records.length} registro(s)?`;
                        Mensaje({
                            title: titulo,
                            icon: demo,
                            buttons: ["Cancelar", "Aceptar"],
                            dangerMode: true,
                        }).then((ok) => {
                            if (!ok) return;
                            useStoreDespachos.getState().eliminarCodbar(records);
                        });
                    }}
                    onPrint={handlePrint}
                    showLeafRecords={true}
                />
            </div>

        </div>
    );
};

export default DespachoTab3;
